import { Component, createRef } from "preact";
import { createPortal } from "preact/compat";
import { useState, useEffect } from "preact/hooks";
import _ from 'lodash';
import { helpers } from "@cargo/common"
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import register from "./register"

import { withPageInfo } from "./page-info-context";
import { history, store } from '../../index'

import ShopProductEditor from '../overlay/shop-product-editor';
import { UsesHost } from "./uses/uses"
import { pausePreactRendering, resumePreactRendering } from '../../helpers';

const NOT_FOUND = 'Product not found';
const OUT_OF_STOCK = 'Out of Stock';
const BUTTON_IN_STOCK = 'Add to Cart';
const BUTTON_NOT_IN_STOCK = 'Unavailable';

const optionAttributeMap = {
	buttonInStockText: 'button-text',
	showPrice: 'show-price',
	mergevariantdropdowns: 'combine-variants',
	product: 'product'
}

const pendingProductFetches = [];
let pendingProductFetchPromise = null;

const fetchProduct = id => {

	if(!pendingProductFetchPromise) {

		pendingProductFetchPromise = new Promise((resolve, reject) => {
			// Start the timer
			requestAnimationFrame(() => {

				store.dispatch(actions.fetchCommerceProducts({
					idArray: pendingProductFetches
				})).then(resolve).catch(reject);

				// clear pending array
				pendingProductFetches.length = 0;

				// clear promise
				pendingProductFetchPromise = null;

			});
		});

	}

	pendingProductFetches.push(id);

	return pendingProductFetchPromise;

}

function formatPriceForCurrency(price, currencyCode, locale, amount) {

	var res;

	if (amount !== undefined) {
		price = price * amount;	
	}

	if (typeof currencyCode !== 'string') {
	
		res = (price / 100) + '';
	
	} else {

		var zeroDecimalCurrencies = ["BIF", "DJF", "GNF", "JPY", "KMF", "KRW", "MGA", "PYG", "RWF", "VND", "VUV", "XAF", "XOF", "XPF"],
			currencyCodes =  {'AED': 'د.إ','AFN': '؋','ALL': 'L','AMD': '֏','ANG': 'ƒ','AOA': 'Kz','ARS': '$','AUD': '$','AWG': 'ƒ','AZN': '₼','BAM': 'KM','BBD': '$','BDT': '৳','BGN': 'лв','BHD': '.د.ب','BIF': 'FBu','BMD': '$','BND': '$','BOB': '$b','BRL': 'R$','BSD': '$','BTC': '฿','BTN': 'Nu.','BWP': 'P','BYR': 'p.','BZD': 'BZ$','CAD': '$','CDF': 'FC','CHF': 'CHF','CLP': '$','CNY': '¥','COP': '$','CRC': '₡','CUC': '$','CUP': '₱','CVE': '$','CZK': 'Kč','DJF': 'Fdj','DKK': 'kr','DOP': 'RD$','DZD': 'دج','EEK': 'kr','EGP': '£','ERN': 'Nfk','ETB': 'Br','ETH': 'Ξ','EUR': '€','FJD': '$','FKP': '£','GBP': '£','GEL': '₾','GGP': '£','GHC': '₵','GHS': 'GH₵','GIP': '£','GMD': 'D','GNF': 'FG','GTQ': 'Q','GYD': '$','HKD': '$','HNL': 'L','HRK': 'kn','HTG': 'G','HUF': 'Ft','IDR': 'Rp','ILS': '₪','IMP': '£','INR': '₹','IQD': 'ع.د','IRR': '﷼','ISK': 'kr','JEP': '£','JMD': 'J$','JOD': 'JD','JPY': '¥','KES': 'KSh','KGS': 'лв','KHR': '៛','KMF': 'CF','KPW': '₩','KRW': '₩','KWD': 'KD','KYD': '$','KZT': 'лв','LAK': '₭','LBP': '£','LKR': '₨','LRD': '$','LSL': 'M','LTC': 'Ł','LTL': 'Lt','LVL': 'Ls','LYD': 'LD','MAD': 'MAD','MDL': 'lei','MGA': 'Ar','MKD': 'ден','MMK': 'K','MNT': '₮','MOP': 'MOP$','MRO': 'UM','MUR': '₨','MVR': 'Rf','MWK': 'MK','MXN': '$','MYR': 'RM','MZN': 'MT','NAD': '$','NGN': '₦','NIO': 'C$','NOK': 'kr','NPR': '₨','NZD': '$','OMR': '﷼','PAB': 'B/.','PEN': 'S/.','PGK': 'K','PHP': '₱','PKR': '₨','PLN': 'zł','PYG': 'Gs','QAR': '﷼','RMB': '￥','RON': 'lei','RSD': 'Дин.','RUB': '₽','RWF': 'R₣','SAR': '﷼','SBD': '$','SCR': '₨','SDG': 'ج.س.','SEK': 'kr','SGD': '$','SHP': '£','SLL': 'Le','SOS': 'S','SRD': '$','SSP': '£','STD': 'Db','SVC': '$','SYP': '£','SZL': 'E','THB': '฿','TJS': 'SM','TMT': 'T','TND': 'د.ت','TOP': 'T$','TRL': '₤','TRY': '₺','TTD': 'TT$','TVD': '$','TWD': 'NT$','TZS': 'TSh','UAH': '₴','UGX': 'USh','USD': '$','UYU': '$U','UZS': 'лв','VEF': 'Bs','VND': '₫','VUV': 'VT','WST': 'WS$','XAF': 'FCFA','XBT': 'Ƀ','XCD': '$','XOF': 'CFA','XPF': '₣','YER': '﷼','ZAR': 'R','ZWD': 'Z$'};

		currencyCode = currencyCode.toUpperCase();

		// if a currency supports decimals, it's price is in cents. Divide by 100 to get the amount in full units.
		if(zeroDecimalCurrencies.indexOf(currencyCode) === -1) {
			price /= 100;
		}

		if(typeof Intl !== "undefined") {
				
			// proper way
			res = new Intl.NumberFormat(locale, {
				style: 'currency',
				currency: currencyCode,
				currencyDisplay: "symbol",
				useGrouping: true,
				minimumFractionDigits: 0
			}).format(price);

		} else {

			// fallback to currency code map for the symbol and regex based thousands separator
			res = (currencyCodes.hasOwnProperty(currencyCode) ? currencyCodes[currencyCode] : currencyCode + ' ') + '' + price.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

		}
	}

	// pad single decimal numbers to double decimals (2.1 > 2.10)
	if(typeof res === "string" && res.indexOf('.') !== -1) {
		var parts = res.split('.');

		if(parts.length === 2 && parts[1].length === 1) {
			parts[1] = parts[1] + '0';
			res = parts.join('.');
		}
	}

	return res;

};

class ProductWidget extends Component {

	constructor(props) {
		
		super(props);
		this.uid = _.uniqueId();

		this.state = {
			loading: true,
			selectedVariant: null
		}

		this.props.fetchShopModel().finally(() => { 
			this.fetchProduct().finally(() => {
				this.setState({
					loading: false
				});
			});
		})

		this.props.baseNode.__commerce_widget__ = this;

	}

	render() {

		let options = this.getOptions();
		
		const {
			baseNode,
			adminMode,
		} = this.props;

		if(!this.props.productData) {

			if(this.state.loading) {
				// do nothing, still loading
				return null;
			} else {
				return createPortal(<>
					{this.props.adminMode && this.props.pageInfo.isEditing && <ShopProductEditor
						shopProductInstance={this.props.baseNode}
					/> }
					<div draggable="true" style={{'display': 'inline-block', 'width': '100%'}}>{NOT_FOUND}</div>
				</>, this.props.baseNode.shadowRoot)
			}
		}

		const outOfStock = this.state.selectedVariant?.inventory !== null && this.state.selectedVariant?.inventory <= 0;
		let usesProps = this.props.uses || '';

		return createPortal(<UsesHost
				uses={usesProps}
				key="shop-product-host"
				adminMode={adminMode}
				customElementMode={true}
				baseNode={baseNode}
			>
				<div draggable="true" style={{'display': 'inline-block', 'width': '100%'}}>
				{this.props.adminMode && <ShopProductEditor
					shopProductInstance={this.props.baseNode}
				/> }

				{this.props.productData ?
					<>
					{ 
						options.showPrice 
						&& this.state.selectedVariant 
						&& <div part="price" class="price">{formatPriceForCurrency(this.state.selectedVariant.price, this.props.currency, this.props.locale)}</div> 
					}	

					{ this.props.productData.attributes ? (

							options.mergevariantdropdowns ? (

								<select part="dropdown" class="dropdown" variant-list onChange={this.getSelectedVariant} >

									{
										this.props.productData.variants.map(productVariation => {

											if(productVariation.is_default) {
												return null;
											}

											return <option value={productVariation.variant_id} dangerouslySetInnerHTML={{__html: _.values(productVariation.attributes).join(', ').replace(/</g, '&lt;')}}></option>
										})
									}

								</select>

							) : (_.keys(this.props.productData.attributes).map(productAttribute => {

								return <select variant-option={ productAttribute } part="dropdown" class="dropdown" onChange={this.getSelectedVariant} >
									<option disabled dangerouslySetInnerHTML={{__html: productAttribute?.replace?.(/</g, '&lt;')}}></option>
									{
										this.getAttributeVariations(productAttribute).map(attributeVariation => 
											<option selected={this.state.selectedVariant?.attributes[productAttribute] === attributeVariation} value={attributeVariation} dangerouslySetInnerHTML={{__html: attributeVariation?.replace?.(/</g, '&lt;')}}></option>
										)
									}
								</select>

							}))
							


					) : null }

					<a part="button" className={`button${outOfStock ? ' out-of-stock': ''}`} onClick={e => {

						if(!outOfStock) {
							this.addToCart(e);
						}
					}}>
						{
							outOfStock ? 
							OUT_OF_STOCK
							: this.state.selectedVariant ? 
								options.buttonInStockText 
								: BUTTON_NOT_IN_STOCK
						}						

					</a>


					
					</>

				: NOT_FOUND }
			
			</div>

		</UsesHost>, this.props.baseNode.shadowRoot)

	}

	onDragStart = (e)=>{
		e.dataTransfer.setData("shop-product-drag", "true");	
	}	

	getAttributeVariations(attribute) {

		var res = _.without(_.uniq(this.props.productData.variants.map(function(variant){
			if(variant.is_available === true && variant.is_default !== true) {
				return variant.attributes[attribute]
			}
		})), undefined);

		var sortedAttributeValues = this.props.productData.attributes[attribute];

		if(sortedAttributeValues) {
			
			res.sort(function(a, b) {
				var indexA = sortedAttributeValues.indexOf(a), 
					indexB = sortedAttributeValues.indexOf(b);

				return ((indexA < indexB) ? -1 : ((indexA == indexB) ? 0 : 1));
			});

		}

		return res;

	}

	getProduct() {

		return this.props.productData;

	}

	getOptions() {

		// convert old widgets
		if(this.props.baseNode.hasAttribute('data-options')) {

			try {

				let legacyOptions = JSON.parse(_.unescape(this.props.baseNode.getAttribute('data-options')));

				_.each(legacyOptions, (value, key) => {
					if(optionAttributeMap[key] && !this.props.baseNode.hasAttribute(optionAttributeMap[key])) {
						this.props.baseNode.setAttribute(optionAttributeMap[key], _.escape(value));
					}
				});

				// kill old options
				this.props.baseNode.removeAttribute('data-options')

			} catch(e) {
				console.error('Unable to read old product widget options', this.props.baseNode)
			}

		}

		let options = _.mapValues(optionAttributeMap, (attributeName, optionName) => {

			if(!this.props.baseNode.hasAttribute(attributeName)) {
				return
			}

			let value = _.unescape(this.props.baseNode.getAttribute(attributeName));

			// coerce some options to bools
			if(optionName === "showPrice" || optionName === "mergevariantdropdowns") {
				value = value == "true";
			}

			return value

		});

		_.defaults(options, {
			showPrice: true,
			mergevariantdropdowns: false,
			buttonInStockText: BUTTON_IN_STOCK
		})

		return options;

	}

	setOptions(changes) {

		_.each(changes, (newValue, option) => {

			if(optionAttributeMap.hasOwnProperty(option)) {
				this.props.baseNode.setAttribute(optionAttributeMap[option], _.escape(newValue));
			}

		});

	}

	addToCart = (e) => {

		if(this.props.adminMode) {
			return;
		}

		this.props.addCommerceProductToCart(this.state.selectedVariant.product_id, this.state.selectedVariant.variant_id);

		// open the cart
		history.push('/cart', {preventScrollReset: true});

	}

	fetchProduct() {

		if(this.props.productData && this.props.productData.product_id == this.props.product) {
			// already have the goods
			return Promise.resolve();
		}
		
		if(!this.props.product || !this.props.shopId ) {
			// no product id
			return Promise.resolve();
		}

		return fetchProduct(this.props.product);

	}

	getSelectedVariant = () => {

		let selectedVariant = null;

		if(this.props.productData) {

			if(this.props.productData.use_default_variant) {

				selectedVariant = this.props.productData.variants.find(variant => variant.is_default === true);

			} else {

				// check dropdowns
				if(this.getOptions().mergevariantdropdowns) {

					let variantID = this.props.baseNode.shadowRoot.querySelector('select[variant-list]')?.value;

					selectedVariant = this.props.productData.variants.find(variant => variant.variant_id == variantID);

				} else {

					var variantConfig = _.reduce(
						this.props.baseNode.shadowRoot.querySelectorAll('select[variant-option]'), 
						function(obj, select){
							obj[select.getAttribute('variant-option')] = select.value;
							return obj;
						}, 
						{}
					);

					selectedVariant = this.props.productData.variants.find(variant => {
						return _.isEqual(variant.attributes, variantConfig);
					});

				}

			}

		}

		if(this.state.selectedVariant !== selectedVariant) {
			this.setState({
				selectedVariant
			})
		}

	}

	componentDidUpdate(prevProps, prevState){

		// Respond to any change except selectedVariant
		if(this.state.selectedVariant === prevState.selectedVariant) {
			this.getSelectedVariant();
		}

	}

	componentDidMount() {
		this.props.baseNode.addEventListener('dragstart', this.onDragStart);
		this.getSelectedVariant();
	}

	componentWillUnmount(){
		this.props.baseNode.removeEventListener('dragstart', this.onDragStart);
	}

}


const ConnectedProductWidget = withPageInfo(connect(
	(state, ownProps) => {

		return {
			adminMode: state.frontendState.adminMode,
			productData: state.commerce.products[ownProps.product],
			currency: state.commerce.shop.currency || 'USD',
			locale: state.commerce.shop.locale || 'en-US',
			shopId: state.site.shop_id,
		};
	}, 
	dispatch => bindActionCreators({
		addCommerceProductToCart: actions.addCommerceProductToCart,
		fetchShopModel: actions.fetchShopModel
	}, dispatch)
)(ProductWidget));


register(
	ConnectedProductWidget, 
	'shop-product', 
	// listen to all attributes used for values
	Object.values(optionAttributeMap), 
	{
		renderIntoShadow: true
	}
);

export default ConnectedProductWidget;
